import { empty } from './strings.js';
export { default as keys } from 'lodash-es/keys.js';
const keyReplacer1 = /\./g;
const keyReplacer2 = /\d*/;
export function generateKey() {
    return (Math.random().toString(36) + Math.random().toString(36))
        .replace(keyReplacer1, empty)
        .replace(keyReplacer2, empty);
}
//# sourceMappingURL=keys.js.map